import { all } from "redux-saga/effects";

import { watchCheckAuth,watchCheckCrbsConfigured } from "./app/base/sagas";
import { watchAuditLogEntities,watchAuditLogs } from "./app/logs/sagas";
import { watchLogin, watchLogout } from "./app/nav/sagas";
import {
  watchAddGlobalAdmin,
  watchAddGroup,
  watchAddService,
  watchAddUser,
  watchCommitPolicies,
  watchFetchChangesets,
  watchGroups,
  watchPermissions,
  watchPolicies,
  watchPreselectResource,
  watchPreselectService,
  watchProducts,
  watchRegisterService,
  watchRemoveGroup,
  watchRemovePolicy,
  watchRemoveService,
  watchRemoveUser,
  watchResources,
  watchResourceTypes,
  watchRoles,
  watchServices,
  watchUsers} from "./app/policies/sagas";

export default function* rootSaga() {
  yield all([
    watchCheckCrbsConfigured(),
    watchCheckAuth(),
    watchProducts(),
    watchServices(),
    watchPreselectService(),
    watchAddService(),
    watchRemoveService(),
    watchRegisterService(),
    watchResources(),
    watchPreselectResource(),
    watchResourceTypes(),
    watchUsers(),
    watchAddUser(),
    watchRemoveUser(),
    watchGroups(),
    watchAddGroup(),
    watchRemoveGroup(),
    watchRoles(),
    watchPolicies(),
    watchPermissions(),
    watchAuditLogs(),
    watchAuditLogEntities(),
    watchCommitPolicies(),
    watchRemovePolicy(),
    watchAddGlobalAdmin(),
    watchLogin(),
    watchLogout(),
    watchFetchChangesets()
  ]);
}
